export default __webpack_public_path__ + "static/media/i217hp.15f7a0aa.webp";